import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentStateInterface, EstateFeatureProps, FieldProps } from '../../../../../../@types/types'
import ChipsGroup from '../../../../../common/inputs/chipsGroup/ChipsGroup'
import { AbstractScreenValidationResult } from '../../../../../../@types/validation-types'
import { getEstateFeatures } from '../../../../../../services/domain/getEstateFeatures'
import { Notification } from 'is24-corecss'
import styles from './EstateFeatures.module.css'

export type AdditionalEstateFeaturesProps = {
  insertionData: ContentStateInterface
  estateFeatures: EstateFeatureProps[]
  labelTranslationKey?: string
  subId?: string
  customLabel?: React.ReactNode
}
const EstateFeatures: React.FC<FieldProps<AbstractScreenValidationResult> & AdditionalEstateFeaturesProps> = ({
  onChange,
  insertionData,
  screenName,
  estateFeatures,
  labelTranslationKey,
  subId,
  customLabel,
  wrapperClassName = 'grid-item',
}) => {
  const { t } = useTranslation()

  // Capture the initial WBS value when component first renders, before user interactions
  const initialWBSValue = useRef(insertionData.estateFeatures?.certificateOfEligibilityNeeded === true)

  // Show message if WBS is currently selected
  const isWBSSelected = insertionData.estateFeatures?.certificateOfEligibilityNeeded === true

  return (
    <div className={wrapperClassName}>
      {customLabel ? (
        customLabel
      ) : (
        <>
          {labelTranslationKey && (
            <span className='font-body-medium-bold'>
              {t(`wizard.screen.${screenName}.labels.${labelTranslationKey}`, 'EstateFeaturesLabel')}
            </span>
          )}
          <span className={`font-body-medium-bold ${labelTranslationKey ? ' margin-left' : ''}`}>
            {t('hints.multipleSelectionPossible', 'Multiple selection possible')}
          </span>
        </>
      )}
      <ChipsGroup
        id={`estate-features${subId ? `-${subId}` : ''}`}
        className='margin-top-xs'
        features={getEstateFeatures(estateFeatures, insertionData, initialWBSValue.current)}
        translation={`estateFeatures.`}
        onChange={(property, value) => {
          onChange({ screen: screenName, property }, value)
        }}
      />

      {isWBSSelected && (
        <div className={styles.smallFont}>
          <Notification
            type='info'
            className='margin-top-l'
            title={t('statusMessage.messages.wbsNotice')}
            variant={'flat'}
          />
        </div>
      )}
    </div>
  )
}

export default EstateFeatures
